import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import SectionSubHeader from "../sectionSubHeader";
import SectionHeader from "../sectionHeader";
import { Link } from "react-router-dom";
import { BsArrowRight } from "react-icons/bs";

const JoinTeam = () => {
  return (
    <div className="section-bg join-team">
      <Container className="" >
      <SectionHeader mainText1="JOIN OUR TEAM"  />
        <Row>
          <Col lg={6}>
           
            <SectionSubHeader headerText="Join our diverse and dynamic team at VOLTO!" />
           
          </Col>
          <Col lg={6}> 
          <p className="text-justify">We’re dedicated to nurturing a diverse and inclusive culture where everyone can thrive. We offer accelerated career growth opportunities, enabling you to make a meaningful impact from day one. </p>
<p className="text-justify">
Join a passionate team focused on helping clients solve complex challenges and make informed decisions. Experience a career that challenges you, surrounded by brilliant colleagues, all while growing together in a collaborative environment.</p>
          </Col>
        </Row>
      </Container>
       
    </div>
  );
};

export default JoinTeam;
